<template>
  <span v-if="showRemark(scope)">
    <el-popover trigger="click" placement="top">
      <div v-if="showDiscount(scope)">
        <p>
          <span>
            {{ $t('addConfigModule.promotionPrice') }}：{{ scope.row.promotionPrice }}
            {{ $t('addConfigModule.yuan') }}
          </span>
        </p>
        <p>
          <span
            v-if="scope.row.discountEndDateTime === null &&
              scope.row.discountStartDateTime === null"
          >
            {{ $t('addConfigModule.promotionTime') }}：{{ $t('addConfigModule.wu') }}
          </span>
          <span
            v-else
          >
            {{ $t('addConfigModule.promotionTime') }}：{{ scope.row.discountStartDateTime }}&nbsp;
            {{ $t('addConfigModule.zhi') }}&nbsp;{{ scope.row.discountEndDateTime }}
          </span>
        </p>
      </div>
      <div v-if="scope.row.isSpdc === 1 && (isPartner && getStore('partnerAuth')==='1' || !isPartner)">
        <p>
          <span>{{ $t('addConfigModule.serviceProviderPrice') }}：{{ scope.row.spdcPrice }}
            {{ $t('addConfigModule.yuan') }}
          </span>
        </p>
        <p v-if="scope.row.isSpdcDiscount !== null && scope.row.isSpdcDiscount === 1">
          <span
            v-if="scope.row.spdcDiscountStartTime === null && scope.row.spdcDiscountEndTime === null"
          >
            {{ $t('addConfigModule.promotionTime') }}：{{ $t('addConfigModule.wu') }}
          </span>
          <span
            v-else
          >
            {{ $t('addConfigModule.promotionTime') }}：{{ scope.row.spdcDiscountStartTime }}&nbsp;
            {{ $t('addConfigModule.zhi') }}&nbsp;{{ scope.row.spdcDiscountEndTime }}
          </span>
        </p>
      </div>
      <p v-html="scope.row.remarks " />

      <div slot="reference" class="name-wrapper">
        <el-tag size="medium">
          <i>
            <img src="../../assets/remark.png" alt="err"></i>
        </el-tag>
      </div>
    </el-popover>
  </span>
</template>

<script>
import { getStore } from '@/utils/mUtils';
export default {
  name: 'MoreContent',
  data () {
    return {};
  },
  components: {},
  props: {
    scope: {
      type: Object,
      default: () => {}
    },
    isPartner: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  methods: {
    getStore,
    showRemark (scope) {
      // eslint-disable-next-line no-mixed-operators
      return !!((scope.row.isSpdc && (this.isPartner && getStore('partnerAuth') === '1' || !this.isPartner)) ||
        // eslint-disable-next-line no-mixed-operators
        (scope.row.isDiscount && scope.row.promotionPrice !== null) && !this.isPartner);
    },
    showDiscount (scope) {
      return !!((scope.row.isDiscount) && !this.isPartner);
    }
  }
};
</script>

<style scoped>

</style>
